module.exports = __webpack_public_path__ + "static/media/sup_dry_cha.38a90052.png";